import './App.css';
import LoginPage from './features/ACS-Auth/LoginPage';
import VerifyOTP from './features/ACS-Auth/VerifyOTP';
import SignUpPage from './features/ACS-Auth/SignUpPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { dashboardChildRoutes } from './routes/ACS-DashboardRoutes';
import OnboardingRoutes from './routes/ACS-OnboardingRoutes';
import DashboardLayout from './components/ACS-Dashboard/ACS-Layout/DashboardLayout';
import { Navigate } from "react-router-dom";
import LoginToastListener from "./components/Listener/LoginToastListener";
import DashboardToastListener from "./components/Listener/DashboardToastListener";
import PasswordSetup from "./features/ACS-Auth/PasswordSetup";
import AboutYou from "./features/ACS-Onboarding/MainOnboarding/AboutYou";
import NotFoundPage from "./features/ACS-Auth/NotFoundPage";
import HostlerJobsView from "./features/ACS-Dashboard-Modules/Yard-Management/HostlerJobsView";
import ProtectedRoute from "./guard/ProtectedRoute";


function App() {
  return (
    <Router>
        <LoginToastListener />
        <DashboardToastListener />
      <Routes>
        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/signup" element={<SignUpPage />} />
        {/* <Route path="/onboarding" element={<Onboarding />} /> */}
        <Route path="/onboarding/*" element={<OnboardingRoutes />} />
          <Route path="/userOrgPassword-setup" element={<PasswordSetup />} />
          <Route path="/userPasswordReset" element={<PasswordSetup />} />
          <Route path="/newOrg-setup" element={<AboutYou />} />
          {/*
            Standalone, chrome-free route (no sidebar/header) for the Hostler persona — their
            account only ever holds HOSTLER:VIEW_GET/JOB_PATCH on the "yardHostler" backend menu
            (see V275__add_hostler_role_and_privileges.sql), never the full dashboard's "yms"
            menu, so there's nothing else for them to see in the normal dashboard shell.
          */}
          <Route
            path="/yard-hostler"
            element={
              <ProtectedRoute module="yardHostler">
                <HostlerJobsView />
              </ProtectedRoute>
            }
          />


        {/* Dashboard Layout wraps all dashboard pages */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          {dashboardChildRoutes}
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App
